<template>
    <div v-if="user.title" class="profile-position">{{ user.title }}</div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "UserJobTitle",
        computed: {
            ...mapGetters("view", ["viewData"]),
            user() {
                return this.viewData.user
            }
        }
    }
</script>